import React, { useState } from "react";
import Tracking from "./Tracking";
import EmailSignature from "./EmailSignature";
import DateTimeSettings from "./DateTimeSettings";
import ContactFitBriefsPanel from "./validation/ContactFitBriefsPanel";
import ValidationJobLog from "./validation/ValidationJobLog";
import {
  pageBodyClass,
  pageClass,
  pageHeaderClass,
  pageSubClass,
  pageTitleClass,
  tabClass,
} from "../common/settingsStyles";

interface SettingsProps {
  selectedClient: string;
  isAdmin: boolean;
}

type SettingsTab = "Tracking" | "DateTime" | "EmailSignature" | "Verification";

const TABS: { key: SettingsTab; label: string }[] = [
  { key: "Tracking", label: "Tracking" },
  { key: "DateTime", label: "Date and time" },
  { key: "EmailSignature", label: "Email signatures" },
  { key: "Verification", label: "Verification" },
];

const Settings: React.FC<SettingsProps> = ({ selectedClient, isAdmin }) => {
  const [settingsSubTab, setSettingsSubTab] = useState<SettingsTab>("Tracking");

  return (
    <div className={`${pageClass} settings-page`}>
      {/* Page header — same chrome as Profile */}
      <div className={`${pageHeaderClass} settings-page-header`}>
        <h1 className={pageTitleClass}>General</h1>
        <p className={pageSubClass}>
          {settingsSubTab === "Verification"
            ? isAdmin
              ? "Targeting briefs for the Target Audience Match check, and what every validation run has cost."
              : "Targeting briefs for the Target Audience Match check and validation run history."
            : "Manage tracking, date and time, and email signature settings for this client."}
        </p>

        <nav className="settings-tabs mt-5 flex gap-8" aria-label="General settings tabs">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setSettingsSubTab(tab.key)}
              className={tabClass(settingsSubTab === tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      <div className={`${pageBodyClass} settings-page-body`}>
        {settingsSubTab === "Tracking" && (
          <Tracking selectedClient={selectedClient} />
        )}
        {settingsSubTab === "DateTime" && (
          <DateTimeSettings selectedClient={selectedClient} />
        )}
        {settingsSubTab === "EmailSignature" && (
          <EmailSignature selectedClient={selectedClient} />
        )}
        {settingsSubTab === "Verification" && (
          <>
            <ContactFitBriefsPanel selectedClient={selectedClient} />
            <div className="mt-8">
              <ValidationJobLog selectedClient={selectedClient} isAdmin={isAdmin} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Settings;
